import React from 'react';
import { useNavigate } from 'react-router-dom';

const AllCourses: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: '100vh',
            background: 'white',
            color: '#4a306d',
            fontFamily: 'Arial, sans-serif'
        }}>
            {/* Hero Section */}
            <section style={{
                textAlign: 'center',
                padding: '0',
                background: 'transparent',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem', width: '100%' }}>
                    {/* Logo */}
                    <div style={{ marginBottom: '1.5rem' }}>
                        <img
                            src="/tdl-logo.jpg"
                            alt="TDL Coaching & Consulting"
                            style={{
                                height: '100px',
                                maxWidth: '500px',
                                width: 'auto',
                                objectFit: 'contain',
                                borderRadius: '8px'
                            }}
                        />
                    </div>

                    <h1 className="hero-title" style={{
                        color: '#4a306d'
                    }}>
                        All Healthcare Training Courses
                    </h1>
                    <h2 className="hero-subtitle" style={{
                        color: '#6b6b6b'
                    }}>
                        Comprehensive Online Training • Flexible Learning • Career Ready Certification
                    </h2>

                    {/* Course Grid */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
                        gap: '2rem',
                        marginTop: '3rem',
                        maxWidth: '1000px',
                        margin: '3rem auto 0'
                    }}>
                        {/* Telemetry Course */}
                        <div style={{
                            background: 'rgba(240, 240, 240, 0.5)',
                            padding: '2rem',
                            borderRadius: '15px',
                            textAlign: 'center',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(52, 168, 168, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>💓</div>
                            <h3 style={{
                                fontSize: '1.5rem',
                                marginBottom: '1rem',
                                color: '#34a8a8'
                            }}>
                                Telemetry Technician
                            </h3>
                            <p style={{ lineHeight: '1.6', opacity: 0.9, marginBottom: '1.5rem' }}>
                                Learn to monitor cardiac rhythms and arrhythmias. 100% online, self-paced learning with weekly live Zoom classes.
                            </p>
                            <div style={{
                                fontSize: '1.5rem',
                                color: '#34a8a8',
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}>
                                Only $59.99
                            </div>
                            <button
                                onClick={() => navigate('/telemetry')}
                                style={{
                                    background: '#34a8a8',
                                    color: 'white',
                                    padding: '0.8rem 1.5rem',
                                    border: 'none',
                                    borderRadius: '25px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                View Course Details
                            </button>
                        </div>

                        {/* Home Health Course */}
                        <div style={{
                            background: 'rgba(240, 240, 240, 0.5)',
                            padding: '2rem',
                            borderRadius: '15px',
                            textAlign: 'center',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                        }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(52, 168, 168, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🏠</div>
                            <h3 style={{
                                fontSize: '1.5rem',
                                marginBottom: '1rem',
                                color: '#34a8a8'
                            }}>
                                Home Health Aide (HHA)
                            </h3>
                            <p style={{ lineHeight: '1.6', opacity: 0.9, marginBottom: '1.5rem' }}>
                                Become a certified Home Health Aide. Provide compassionate care in home settings with flexible, self-paced training.
                            </p>
                            <div style={{
                                fontSize: '1.5rem',
                                color: '#34a8a8',
                                fontWeight: 'bold',
                                marginBottom: '1rem'
                            }}>
                                Only $59.99
                            </div>
                            <button
                                onClick={() => navigate('/home-health')}
                                style={{
                                    background: '#34a8a8',
                                    color: 'white',
                                    padding: '0.8rem 1.5rem',
                                    border: 'none',
                                    borderRadius: '25px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                View Course Details
                            </button>
                        </div>
                    </div>

                    {/* Coming Soon Section */}
                    <div style={{ marginTop: '4rem', textAlign: 'center' }}>
                        <h2 style={{
                            fontSize: '2.5rem',
                            color: '#4a306d',
                            marginBottom: '1rem'
                        }}>
                            Coming Soon
                        </h2>

                        <h3 style={{
                            fontSize: '1.8rem',
                            color: '#34a8a8',
                            marginBottom: '3rem',
                            fontWeight: 'bold'
                        }}>
                            LET'S CATCH IT
                        </h3>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                            gap: '2rem',
                            marginBottom: '3rem'
                        }}>
                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1rem',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s ease'
                            }}>
                                <img
                                    src="/med_tech.jpg"
                                    alt="Medication technician"
                                    style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginBottom: '1rem'
                                    }}
                                />
                                <h3 style={{
                                    fontSize: '1.2rem',
                                    color: '#4a306d',
                                    marginBottom: '0.5rem'
                                }}>
                                    Medication technician certification
                                </h3>
                            </div>

                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1rem',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s ease'
                            }}>
                                <img
                                    src="/nurse_doing_an_assessment.jpg"
                                    alt="Nursing assessment"
                                    style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginBottom: '1rem'
                                    }}
                                />
                                <h3 style={{
                                    fontSize: '1.2rem',
                                    color: '#4a306d',
                                    marginBottom: '0.5rem'
                                }}>
                                    nursing head-to-toe assessment course
                                </h3>
                            </div>

                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1rem',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s ease'
                            }}>
                                <img
                                    src="/phebotomy_tech.jpg"
                                    alt="Phlebotomy technician"
                                    style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginBottom: '1rem'
                                    }}
                                />
                                <h3 style={{
                                    fontSize: '1.2rem',
                                    color: '#4a306d',
                                    marginBottom: '0.5rem'
                                }}>
                                    Phlebotomy technician certification
                                </h3>
                            </div>

                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1rem',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                transition: 'transform 0.3s ease'
                            }}>
                                <img
                                    src="/cna_picture.jpg"
                                    alt="Certified nursing assistant"
                                    style={{
                                        width: '100%',
                                        height: '200px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginBottom: '1rem'
                                    }}
                                />
                                <h3 style={{
                                    fontSize: '1.2rem',
                                    color: '#4a306d',
                                    marginBottom: '0.5rem'
                                }}>
                                    Certified nursing assistant (CNA)
                                </h3>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


        </div>
    );
};

export default AllCourses;